import api from '../../lib/api';
import { Credentials, LoginResponse, MfaLoginPayload, RegisterPayload, RegisterResponse, UserResponse } from './types';

export async function loginApi(credentials: Credentials): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>('platform/auth/login', credentials);
  return data;
}

export async function completeMfaLoginApi(payload: MfaLoginPayload): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>('platform/auth/login/mfa', payload);
  return data;
}

export async function registerApi(payload: RegisterPayload): Promise<RegisterResponse> {
  const { data } = await api.post<RegisterResponse>('platform/auth/register', payload);
  return data;
}

export async function logoutApi(): Promise<{ success: boolean; message: string }> {
  const { data } = await api.post<{ success: boolean; message: string }>('platform/auth/logout');
  return data;
}

export interface VerifyTokenResponse {
  success: boolean;
  user?: { userId: number; email: string; role: string };
}

export async function verifyTokenApi(): Promise<VerifyTokenResponse> {
  const { data } = await api.get<VerifyTokenResponse>('platform/auth/verify');
  return data;
}

export async function setProfileImageApi(attachmentId: string): Promise<UserResponse> {
  const { data } = await api.post<{ success: boolean; user: UserResponse }>(
    'platform/auth/profile-image',
    { attachmentId },
    { skipErrorToast: true },
  );
  return data.user;
}
